<template>
  <div class="index" v-cloak>
    
      <SYBuyList :allBuyArray="allBuyArray" :score="score" :numList="numList" :count="count" :is-sort="false" v-if="resData.length > 0"></SYBuyList>

      <div class="title acea-row row-between-wrapper" v-if="resData.length < 1">
        <div class="noData">
          暂无数据
        </div>
      </div>

  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import SYBuyList from "@components/SYBuyList";
import { getBuyStudentList } from "@api/public";
import cookie from "@utils/store/cookie";
import { openShareAppMessage, openShareTimeline, ready } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import { parseQuery } from "@utils/index";

export default {
  name: "user",
  components: {
    swiper,
    swiperSlide,
    SYBuyList
  },
  props: {},
  data: function() {
    return {
      count: 0,
      score: 0,
      numList:{},
      resData:[],
      allBuyArray:{}
    };
  },
  mounted: function() {
    let that = this;

    let param = parseQuery();

    this.productId = param.productId;
    let openid = cookie.get("lishu-openid");

    // obj.push({"aaa":[111,222]});
    // that.allBuyArray["aaa"] = [["111","222",""]];

    // Object.keys(that.allBuyArray).forEach(function(key){

    //     console.log(key,that.allBuyArray[key]);

    // });

    // that.addBuyNameToArray("长安二中高一(3)班", "张三", 10);
   

    if (openid) {
      getBuyStudentList(this.productId, openid).then(data => {
          console.log(data.data);
          if (data.code == 0) {
            that.$set(that, "resData", data.data);
            console.log("resData");
            for (let index = 0; index < data.data.length; index++) {
              const element = data.data[index];
              that.addBuyNameToArray(element.buySchool+element.buyClass, element.buyPersonName, element.integral);
            }

          }else if (data.code == 301){
            console.log(data.msg);
          }
      });
    }
  },
  methods: {
    addBuyNameToArray: function(classname, name, price){
      let that = this;
      that.count++;
      that.score += price;

      if(that.allBuyArray.hasOwnProperty(classname)){
        if (that.allBuyArray[classname].length > 0) {
          let tLength = that.allBuyArray[classname].length;
          let havePos = false;
          for (let index = 0; index < that.allBuyArray[classname][tLength - 1].length; index++) {
            const element = that.allBuyArray[classname][tLength - 1][index];
            if (element == "") {
              that.allBuyArray[classname][tLength - 1][index] = name;
              that.numList[classname] = that.numList[classname]+1;
              havePos = true;
              break;
            }
          }

          if (havePos == false) {
            let tArray = [name, "", ""];
            that.allBuyArray[classname].push(tArray);
            that.numList[classname] = that.numList[classname]+1;
          }
        }
      }else{
        that.allBuyArray[classname] = [[name, "", ""]];
        that.numList[classname]=1;
      }
    },
    setOpenShare: function() {
      getShare().then(res => {
        var data = res.data.data;
        var configAppMessage = {
          desc: data.synopsis,
          title: data.title,
          link: location.href,
          imgUrl: data.img
        };
        var configTimeline = {
          title: data.title,
          link: location.href,
          imgUrl: data.img
        };
        if (isWeixin() === true) {
          ready().then(() => {
            openShareAppMessage(configAppMessage).then(() => {});
            openShareTimeline(configTimeline).then(() => {});
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.index {
  background-color: #fff;
}
.noData {
  font-size: 20px;
  color: #888888;
  margin:0 auto;
  margin-top: 50%;
}

.syTitle {
  background-color: #e93323;
  color: #fff;
  font-size: 20px;
}
</style>
